import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleArrowLeft.svg",
  "use": "CircleArrowLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleArrowLeft.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm0-44A20,20,0,1,0,51.8989,34H26.8281l7.5871,7.5729a2.0016,2.0016,0,0,1-2.8324,2.829L20.56,33.3974a1.9981,1.9981,0,0,1,0-2.8289L31.5828,19.5639a2.0017,2.0017,0,0,1,2.8324,2.8292L26.7941,30H51.8989A20.0006,20.0006,0,0,0,32,12Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol